import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

// Attach Authorization header from localStorage as fallback (for cross-site cookie issues)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("bula_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Surface CORS / network failures to a global listener (ApiHealthBanner).
// A successful response (any 2xx-4xx that came back with headers) signals
// recovery — only `code: 'ERR_NETWORK'` (no response) indicates a true
// CORS / DNS / offline failure.
api.interceptors.response.use(
    (res) => {
        try {
            window.dispatchEvent(new CustomEvent("bula:api-recovered"));
        } catch { /* SSR safety */ }
        return res;
    },
    (err) => {
        const isNetwork = err && (err.code === "ERR_NETWORK" || err.message === "Network Error") && !err.response;
        try {
            if (isNetwork) {
                window.dispatchEvent(new CustomEvent("bula:api-failed", { detail: { url: err.config?.url } }));
            } else if (err && err.response) {
                window.dispatchEvent(new CustomEvent("bula:api-recovered"));
            }
        } catch { /* SSR safety */ }
        return Promise.reject(err);
    }
);

export const fileUrl = (fileId) => `${API}/files/${fileId}`;

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function fmtFJD(amount) {
    if (amount == null) return "—";
    return `FJD $${Number(amount).toLocaleString("en-FJ", { maximumFractionDigits: 0 })}`;
}
